<template lang="html">
  <v-menu left top offset-x class="widthSettingMenu" :close-on-click="true" :close-on-content-click="false" v-model="menu">
    <div class="textCenter" slot="activator">
      <v-layout row wrap>
        <v-flex xs12>
          <span class="pl-1 cursorpointer colorFooterMenu" v-if="statusroom !== 'close'"><v-icon style="font-size: 14px;">settings</v-icon> ตัวเลือก</span>
          <span class="pl-1 cursorpointer colorFooterMenu" v-else disabled><v-icon style="font-size: 14px;">settings</v-icon> ตัวเลือก</span>
        </v-flex>
      </v-layout>
    </div>
    <div class="setBGMenuSetting setMaxWidthMenuSetting">
        <v-layout row wrap align-center justify-center style="background-color: #e0e0e0;">
          <v-flex xs3>
            <v-avatar class="f-l mr-2 user-photoprofilechat" >
              <img src="/static/img/call-center.png" alt="John" class="alligator-turtle">
            </v-avatar>
          </v-flex>
          <v-flex xs7>
            <span v-if="statusroom !== 'close'"><b>ตัวเลือก</b></span>
            <span v-else disabled><b>ตัวเลือก</b></span>
          </v-flex>
          <v-flex xs2>
            <span><v-icon style="cursor: pointer;" @click="menu = false">close</v-icon></span>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 v-if="statusroom !== 'close'">
           <div v-for="(item, index) in listmenu"  style="margin-bottom: 1px;">
            <div v-if="item.label != 'v-divider'" @click="clickchange(item.value, index)" class="cursorpointer colorMenu">
              <span  style="margin-left: 1vw; margin-right: 170px;"> {{item.label}} </span>
              <v-icon  style="font-size: 15px;">{{item.icon}}</v-icon>
            </div>
            <v-divider v-else style="margin-top: 2px;margin-bottom: 2px;"></v-divider>
           </div>
          </v-flex>
          <v-flex xs12 v-else>
            <div style="width: 100%;"> 
              <span  style="margin-left: 1vw; margin-right: 170px;" disabled>เสียง</span>
              <v-icon  style="font-size: 15px;" disabled>fas fa-volume-off</v-icon>
             </div>
             <v-divider style="margin-top: 2px; margin-bottom: 2px;"></v-divider>
             <div style="width: 100%;"> 
                <span  style="margin-left: 1vw;" disabled>ส่งไฟล์</span>
             </div>
              <v-divider style="margin-top: 2px; margin-bottom: 2px;"></v-divider>
             <div class="cursorpointer colorMenu" style="width: 100%;"> 
                <span  style="margin-left: 1vw;" @click="clickchange('endchatpage')" disabled>สิ้นสุดการสนทนา</span>
             </div>
          </v-flex>
        </v-layout>
    </div>
    <div style="display: none;">
      <input  type="file" id="uploadfileChat" @change="onFileSelected" />
    </div>
  </v-menu>
</template>

<script>
import { sync } from 'vuex-pathify'
const theme = require('../assets/theme')
export default {
  data () {
    return {
      theme,
      listmenu: [
        {label: 'เสียง', value: 'sound', icon: 'fas fa-volume-up'},
        // {label: 'เกี่ยวกับ', value: '', icon: ''},
        {label: 'v-divider'},
        {label: 'ส่งไฟล์', value: 'sendfile', icon: ''},
        {label: 'v-divider'},
        {label: 'สิ้นสุดการสนทนา', value: 'endchat', icon: ''}
      ],
      menu: false,
      selectFile: null,
      tokenroom: '',
      concode: '',
      servicename: '',
      header: '',
      body: '',
      tokenservice: '',
      tokenuser: '',
      statusroom: ''
    }
  },
  created () {
    this.statusroom = this.mystatusroom
    // console.log(this.statusroom)
    this.tokenroom = this.$route.params.tokenroom
    this.concode = this.$route.params.concode
    this.servicename = this.$route.params.servicename
    this.tokenuser = this.mytokenuser
    // this.tokenservice = localStorage.getItem('tokenservice')
    var servicename = this.myservicename
    if (this.theme[servicename].servicename === this.myservicename) {
      this.tokenservice = 'Bearer ' + this.theme[servicename].authen
      // console.log(this.tokenservice)
    }
  },
  computed: {
    ...sync('*')
  },
  methods: {
    clickchange (value, index) {
      // console.log(value + 'lllll' + index)
      if (value === '') {
      } else if (value === 'sound') {
        if (this.listmenu[index].icon === 'fas fa-volume-up') {
          this.listmenu[index].icon = 'fas fa-volume-off'
          this.$emit('sound', false)
        } else {
          this.listmenu[index].icon = 'fas fa-volume-up'
          this.$emit('sound', true)
        }
      } else if (value === 'endchat') {
        // alert('จบการสนทนา')
        this.closeTicket()
      } else if (value === 'sendfile') {
        this.upfile(value)
      } else if (value === 'endchatpage') {
        this.$router.push('/score/' + this.servicename + '/' + this.concode + '/' + this.tokenroom)
      }
    },
    upfile (data) {
      $('#uploadfileChat').click()
      // document.getElementById('#uploadfileChat').click()
    },
    onFileSelected (data) {
      this.selectFile = data.target.files[0]
      this.$emit('pushfile', this.selectFile, this.selectFile.name)
      document.querySelector('#uploadfileChat').value = ''
      this.menu = false
    },
    closeTicket () {
      this.$swal({
        title: '<div style="font-size: 18px;">คุณต้องการจบการสนทนา ?</div>',
        text: '',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#7f7f7f',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          // console.log(this.tokenservice)
          this.header = {headers: {'Authorization': this.tokenservice}}
          this.body = {tokenroom: this.tokenroom, tokenuser: this.tokenuser}
          this.axios.post(process.env.APImanage + '/close_ticket_by_guest', this.body, this.header).then((response) => {
            // console.log(response.data)
            if (response.data.status === 'success') {
              // this.$swal({
              //   title: '<div style="font-size: 18px;">ยกเลิกการสนทนาสำเร็จ</div>',
              //   text: '',
              //   type: 'success',
              //   confirmButtonColor: '#3085d6',
              //   confirmButtonText: 'ตกลง'
              // })
              this.$router.push('/rating/' + this.servicename + '/' + this.concode + '/' + this.tokenroom)
            } else {
              // console.log('close ticket error')
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.colorFooterMenu {
  color: #424242;
  font-size: 12px;
}
.colorMenu:hover {
  color: green
}
>>> .tabs__container--fixed-tabs .tabs__div, .tabs__container--icons-and-text .tabs__div, .tabs__container--centered .tabs__div {
  min-width: 0px;
}
.setFontEmo{
  font-size: 28px;
}
.setMaxHeight {
  min-height: 300px !important;
  max-height: 300px !important;
  overflow-y: scroll;
}
.setMaxWidthMenuSetting {
  width: 250px !important;
  max-width: 250px !important;
}
.setBGMenuSetting {
  background-color: white !important;
}
.setHeightEmoji:hover > i {
  color: green !important;
}
.setHeightEmoji{
  position: relative;
  top: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/Menusetting.vue